// removed by extract-text-webpack-plugin
module.exports = {"dropdown-open":"DropdownButton__dropdown-open","dropdownOpen":"DropdownButton__dropdown-open","icon-chevron-white":"DropdownButton__icon-chevron-white","iconChevronWhite":"DropdownButton__icon-chevron-white","icon-chevron-gray":"DropdownButton__icon-chevron-gray","iconChevronGray":"DropdownButton__icon-chevron-gray","dropdown-close":"DropdownButton__dropdown-close","dropdownClose":"DropdownButton__dropdown-close","animate":"DropdownButton__animate"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/atoms/DropdownButton/DropdownButton.scss
// module id = 1770
// module chunks = 8